import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  // Default: localStorage > browser > en
  const browserLang = navigator.language?.startsWith("th") ? "th" : "en";
  const [lang, setLang] = useState(localStorage.getItem("lang") || browserLang);

  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

// Custom hook
export function useLang() {
  return useContext(LanguageContext);
}